import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@constants/QueryCacheKey';

function useEventQuery(id, options) {
  return useQuery(QUERY_CACHE_KEY.event(id), { ...options, staleTime: 10 * 60 * 1000 });
}

export default useEventQuery;
